import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { Image } from 'src/shared/components/image';
import { Loader } from 'src/shared/components/loader';
import EmptyImage from 'public/assets/images/emptyImage.svg';
export function Preview({ image, isLoading }) {
    const hasImage = Boolean(image);
    const currentImage = image || EmptyImage;
    return (_jsx("div", { className: "flex aspect-video items-center justify-center overflow-hidden rounded-extralarge bg-neutral-200 sm:w-[232px]", children: isLoading ? (_jsx(Loader, { full: "screen", "data-testid": "cover-loader" })) : (_jsx(Image, { alt: "", "aria-hidden": true, src: currentImage, "data-testid": "cover-image-preview", className: clsx({
                '_w-full _h-full object-cover object-center': hasImage,
                '_w-7 _h-7': !hasImage
            }) }, currentImage)) }));
}
